import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";
import axios from "axios";

// 80G Form API
export const eightyFormAction = async (data) => {
  try {
    const baseURL = import.meta.env.VITE_API_BASE_URL;
    const token = localStorage.getItem("authToken");
    
    // API now returns JSON with pdfUrl instead of blob
    const response = await axios.post(
      `${baseURL}${API_ENDPOINTS.EIGHTYFORM}`,
      {
        userId: data.userId,
        transactionId: data.transactionId,
        details: data.details
      },
      {
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` })
        },
        responseType: 'json', // Changed from 'blob' to 'json'
        timeout: 60000
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// 10B Form API - Get list of 10B forms
export const getTenbeList = async (userId) => {
  try {
    const response = await axiosInstance.get(API_ENDPOINTS.TENBE_LIST.replace(':id', userId));
    return response;
  } catch (error) {
    throw error;
  }
};

// Update transaction 80G download status
export const updateTransactionEightyG = async (transactionId) => {
  try {
    const baseURL = import.meta.env.VITE_API_BASE_URL;
    const url = baseURL.endsWith('/api') 
      ? `${baseURL}/transactions/${transactionId}`
      : `${baseURL}/api/transactions/${transactionId}`;
    
    const response = await axios.put(url, { eightyG: true });
    return response;
  } catch (error) {
    throw error;
  }
};

// Update 10B download status
export const updateTransactionTenbe = async (pan, financialYear) => {
  try {
    const baseURL = import.meta.env.VITE_API_BASE_URL;
    const url = baseURL.endsWith('/api')
      ? `${baseURL}/tenbe/${pan}/${financialYear}`
      : `${baseURL}/api/tenbe/${pan}/${financialYear}`;
    
    const response = await axios.put(url);
    return response;
  } catch (error) {
    throw error;
  }
};

// Get transaction history for user
export const getTransactionHistory = async (userId) => {
  try {
    const response = await axiosInstance.get(API_ENDPOINTS.GET_USER_TRANSACTIONS(userId));
    return response;
  } catch (error) {
    throw error;
  }
};

